import { APIURL } from "../models/api-base";
import { apiUrl_liveCategories } from "../models/api-urls";
import fetchService from "../modules/APIService";

class Service extends fetchService {
    constructor() {
        super(APIURL);
    }

    getAll = async () => {
        const response = await this.get(apiUrl_liveCategories);
        return response;
    };

    getById = async (id) => {
        const response = await this.get(`${apiUrl_liveCategories}/${id}`);
        return response;
    };

    create = async (data) => {
        const response = await this.post(apiUrl_liveCategories, data);
        return response;
    };

    update = async (id, data) => {
        const response = await this.put(`${apiUrl_liveCategories}/${id}`, data);
        return response;
    };

    remove = async (id) => {
        const response = await this.delete(`${apiUrl_liveCategories}/${id}`);
        return response;
    };

    reorder = async (order) => {
        const response = await this.post(`${apiUrl_liveCategories}/reorder`, { order });
        return response;
    };
}

const LiveCategoriesService = new Service();
export default LiveCategoriesService;
